import { render, staticRenderFns } from "./PhoneWithPrefix.vue?vue&type=template&id=83d9772a&lang=pug&"
import script from "./PhoneWithPrefix.vue?vue&type=script&lang=ts&"
export * from "./PhoneWithPrefix.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneWithPrefix.vue?vue&type=style&index=0&id=83d9772a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports